module.exports = __webpack_public_path__ + "img/yzh9.506b70ff.jpg";